import { DocumentData } from "@angular/fire/firestore";
import { DayOfWeekSchedule } from "../../product/enums/day-of-week-schedule";
import { CategoryException } from "./exceptions/category.exceptions.model";
import { CategorySchedule } from "./menu.category.schedule.model";

export class CategoryScheduleBuilder {
  private _activeWeekdays: DayOfWeekSchedule;
  private _exceptions: CategoryException[];

  constructor() {
    this.default();
  }

  public get hasActiveWeekday(): boolean {
    return (
      this.isActiveFriday ||
      this.isActiveMonday ||
      this.isActiveSaturday ||
      this.isActiveThursday ||
      this.isActiveTuesday ||
      this.isActiveWednesday ||
      this.isActiveSunday
    );
  }

  public get activeWeekdays(): DayOfWeekSchedule {
    return this._activeWeekdays;
  }
  public set activeWeekdays(dow: DayOfWeekSchedule) {
    this._activeWeekdays = dow;
  }
  public get isActiveMonday(): boolean {
    return this._activeWeekdays.monday;
  }
  public get isActiveTuesday(): boolean {
    return this._activeWeekdays.tuesday;
  }
  public get isActiveWednesday(): boolean {
    return this._activeWeekdays.wednesday;
  }
  public get isActiveThursday(): boolean {
    return this._activeWeekdays.thursday;
  }
  public get isActiveFriday(): boolean {
    return this._activeWeekdays.friday;
  }
  public get isActiveSaturday(): boolean {
    return this._activeWeekdays.saturday;
  }
  public get isActiveSunday(): boolean {
    return this._activeWeekdays.sunday;
  }

  public get exceptions(): CategoryException[] {
    return this._exceptions;
  }
  public addException(exception: CategoryException) {
    this._exceptions.push(exception);
  }
  public removeException(exception: CategoryException) {
    for (var i = 0; i < this._exceptions.length; i++) {
      if (this._exceptions[i].compare(exception)) {
        this._exceptions.splice(i, 1);
        return;
      }
    }
  }
  public get exceptionsOnMonday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "monday");
  }
  public get exceptionsOnTuesday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "tuesday");
  }
  public get exceptionsOnWednesday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "wednesday");
  }
  public get exceptionsOnThursday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "thursday");
  }
  public get exceptionsOnFriday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "friday");
  }
  public get exceptionsOnSaturday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "saturday");
  }
  public get exceptionsOnSunday(): CategoryException[] {
    return this._exceptions.filter(e => e.day == "sunday");
  }

  public default() {
    this._activeWeekdays = DayOfWeekSchedule.all();
    this._exceptions = [];
  }

  public load(data: DocumentData): CategoryScheduleBuilder {
    if (data == null) this.default();
    else {
      this._activeWeekdays = new DayOfWeekSchedule(data.activeWeekdays);
      this._exceptions =
        data.exceptions == null
          ? []
          : data.exceptions.map((e: DocumentData) =>
              new CategoryException(e.day).load(e)
            );
    }

    return this;
  }

  public edit(data: CategorySchedule): CategoryScheduleBuilder {
    if (data != null) {
      this._activeWeekdays = new DayOfWeekSchedule(data.activeWeekdays);
      this._exceptions = data.exceptions.map(e =>
        new CategoryException(e.day).edit(e)
      );
    } else {
      this.default();
    }

    return this;
  }

  public toJSON = () => ({
    activeWeekdays: this._activeWeekdays.toJSON(),
    exceptions: this.exceptions.map(e => e.toJSON())
  });
}
